import { Button, Icon, Typography, VerticalDivider } from '@smartgift/frontend-toolkit';
import PropTypes from 'prop-types';
import React from 'react';
import { Trans, useTranslation } from 'react-i18next';

import { useAddTagModal } from '@hero/hooks';
import { useGetTagList } from '@hero/services/contact-service/hooks';

import { TagTable } from '../Table';

import * as S from './style';

function AddTagsTable({
  selectedRows,
  disabledRows,
  onChangeSelectedRows,
  showAddTags = true,
  defaultSelectedTags,
  disabledColumns,
  isEditContactsModalOpen,
  setIsEditContactModal,
  isDeleteActionShown
}) {
  const { t } = useTranslation();
  const { data: tags } = useGetTagList();
  const { addTag } = useAddTagModal();

  return (
    <S.AddTagsWrapper>
      <S.TableHeader>
        <S.TitleWrapper>
          <Typography variant="body2Bold">{t('tags')}</Typography>
          <VerticalDivider $height="24px" $margin="0 12px" />
          <Typography variant="body2">
            <Trans
              i18nKey="totalTags"
              values={{ count: tags?.pagination?.total || 0 }}
              components={{ b: <b /> }}
            />
          </Typography>
        </S.TitleWrapper>
        {showAddTags && (
          <Button variant="text" onClick={addTag} size="sm">
            <Icon name="add" px="24px" space={5} />
            {t('addTags')}
          </Button>
        )}
      </S.TableHeader>

      <TagTable
        selectable
        isDeleteActionShown={isDeleteActionShown}
        selectedRows={selectedRows}
        disabledRows={disabledRows}
        onChangeSelectedRows={onChangeSelectedRows}
        defaultSelectedTags={defaultSelectedTags}
        disabledColumns={disabledColumns}
        isEditContactsModalOpen={isEditContactsModalOpen}
        setIsEditContactModal={setIsEditContactModal}
      />
    </S.AddTagsWrapper>
  );
}

AddTagsTable.propTypes = {
  selectedRows: PropTypes.array,
  disabledRows: PropTypes.array,
  onChangeSelectedRows: PropTypes.func,
  showAddTags: PropTypes.bool,
  defaultSelectedTags: PropTypes.array,
  disabledColumns: PropTypes.array,
  isEditContactsModalOpen: PropTypes.bool,
  setIsEditContactModal: PropTypes.func,
  isDeleteActionShown: PropTypes.bool
};

export { AddTagsTable };
